import { trainers } from "../content/siteContent";

export function TrainerGrid() {
  return (
    <div className="trainer-grid">
      {trainers.map((trainer) => (
        <article className="trainer" key={trainer.name}>
          <div className="trainer-image-frame">
            <img src={trainer.image} alt={trainer.imageAlt} />
          </div>
          <h3>{trainer.name}</h3>
          <p>{trainer.certification}</p>
          <span className="trainer-line" aria-hidden="true" />
        </article>
      ))}
    </div>
  );
}
